module.exports = __webpack_public_path__ + "static/media/1f48e.a90e9cfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f48e.svg
// module id = 646
// module chunks = 1